import { theme } from '@zappyrent/hundop';
import styled from 'styled-components';

type ColorsType = 'deepBlue' | 'grayson';

const Colors: Record<ColorsType, string> = {
  deepBlue: theme.colors.cross.deepBlu,
  grayson: theme.colors.cross.grayson,
};

const getColor = (color: ColorsType | undefined): string =>
  color && Colors[color] ? Colors[color] : '#000';

type TextProp = {
  color?: ColorsType;
  fontWeight?:
    | 'bold'
    | 'bolder'
    | 'lighter'
    | 'normal'
    | 100
    | 200
    | 300
    | 400
    | 500
    | 600
    | 700
    | 800
    | 900;
  textAlign?: 'start' | 'center' | 'end';
  alignSelf?: 'start' | 'center' | 'end';
  margin?: string;
  padding?: string;
  smPadding?: string;
  mdPadding?: string;
  lgPadding?: string;
};

export const H1Text = styled.h1<TextProp>`
  color: ${({ color }) => getColor(color)};
  font-family: 'Nunito';
  font-weight: bold;
  margin: 0;
  padding: ${({ padding }) => padding ?? '0'};
  text-align: ${({ textAlign }) => textAlign ?? 'center'};
  align-self: ${({ alignSelf }) => alignSelf ?? 'start'};
  @media screen and (min-width: 768px) {
    padding: ${({ smPadding, padding }) => smPadding ?? padding ?? '0'};
  }
  @media screen and (min-width: 1024px) {
    padding: ${({ mdPadding, smPadding, padding }) =>
      mdPadding ?? smPadding ?? padding ?? '0'};
  }
  @media screen and (min-width: 1280px) {
    padding: ${({ lgPadding, mdPadding, smPadding, padding }) =>
      lgPadding ?? mdPadding ?? smPadding ?? padding ?? '0'};
  }
`;

export const H2Text = styled.h2<TextProp>`
  color: ${({ color }) => getColor(color)};
  font-family: 'Nunito';
  font-weight: bold;
  margin: 0;
  padding: ${({ padding }) => padding ?? '0'};
  text-align: ${({ textAlign }) => textAlign ?? 'center'};
  align-self: ${({ alignSelf }) => alignSelf ?? 'start'};
  @media screen and (min-width: 768px) {
    padding: ${({ smPadding, padding }) => smPadding ?? padding ?? '0'};
  }
  @media screen and (min-width: 1024px) {
    padding: ${({ mdPadding, smPadding, padding }) =>
      mdPadding ?? smPadding ?? padding ?? '0'};
  }
  @media screen and (min-width: 1280px) {
    padding: ${({ lgPadding, mdPadding, smPadding, padding }) =>
      lgPadding ?? mdPadding ?? smPadding ?? padding ?? '0'};
  }
`;

export const H3Text = styled.h3<TextProp>`
  color: ${({ color }) => getColor(color)};
  font-family: 'Nunito';
  font-weight: ${({ fontWeight }) => fontWeight ?? 'bold'};
  margin: 0;
  padding: ${({ padding }) => padding ?? '0'};
  text-align: ${({ textAlign }) => textAlign ?? 'center'};
  align-self: ${({ alignSelf }) => alignSelf ?? 'start'};
  @media screen and (min-width: 768px) {
    padding: ${({ smPadding, padding }) => smPadding ?? padding ?? '0'};
  }
  @media screen and (min-width: 1024px) {
    padding: ${({ mdPadding, smPadding, padding }) =>
      mdPadding ?? smPadding ?? padding ?? '0'};
  }
  @media screen and (min-width: 1280px) {
    padding: ${({ lgPadding, mdPadding, smPadding, padding }) =>
      lgPadding ?? mdPadding ?? smPadding ?? padding ?? '0'};
  }
`;
export const PText = styled.p<TextProp>`
  color: ${({ color }) => getColor(color)};
  font-family: 'Nunito';
  font-weight: 400;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  margin: ${({ margin }) => margin ?? 0};
  padding: ${({ padding }) => padding ?? '0'};
  text-align: ${({ textAlign }) => textAlign ?? 'center'};
  align-self: ${({ alignSelf }) => alignSelf ?? 'start'};
  @media screen and (min-width: 768px) {
    padding: ${({ smPadding, padding }) => smPadding ?? padding ?? '0'};
  }
  @media screen and (min-width: 1024px) {
    padding: ${({ mdPadding, smPadding, padding }) =>
      mdPadding ?? smPadding ?? padding ?? '0'};
  }
  @media screen and (min-width: 1280px) {
    padding: ${({ lgPadding, mdPadding, smPadding, padding }) =>
      lgPadding ?? mdPadding ?? smPadding ?? padding ?? '0'};
  }
`;
